import { ENV_DEVELOPMENT } from '@vfde-fe/sails_core';

/**
 * Handle Legacy click event bindings
 * Ugly: this function rebinds legacy component click events within the brix overlay to make them work (e.g. footnotes)
 *
 * @TODO Remove as soon as issue is fixed in core.js by using event delegation or components are in brix
 */
export const handleLegacyClickEventBindings = (overlay?) => {

    if (process.env.NODE_ENV !== ENV_DEVELOPMENT) {
        try {
            if (overlay) {
                // Initialize simplicity accordion
                (window as any).vf.toggle.init(overlay.containerElement.getElementsByClassName('overlay__container')[0]);
            }

            // Initialize simplicity footnotes
            (window as any).vf.footnotes.init();

            // Initialize simplicity equal height script
            (window as any).vf['eq-height'].init();

            // Initialize simplicity responsive tables
            if ((window as any).vf['responsive-table']) {
                (window as any).vf['responsive-table'].init();
            }
        } catch (err) {
            // can't do anything about that
        }
    }
};
